import { ElementRef } from '@angular/core';
import { PageBase } from 't4core';
import { ServiceLocator } from 't4core';
import { NavigationService } from '../Services/NavigationService/navigation-service.service';




export class AppPageBase extends PageBase {

  private PageName: string = "Unknown";
  public navigation: NavigationService;

  constructor(el: ElementRef, pageName: string = "turbo") {
    super(el, "Intellitrailer");

    this.navigation = ServiceLocator.injector.get(NavigationService);

    this.PageName = pageName;
  }

  public executeCommand(command, params?:any, isGoingBack?:boolean):Promise<void> {
    return this.navigation.executeCommand(command, params, isGoingBack, this.PageName);
  }

}
